const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || 'http://127.0.0.1:8000/api';

export const reservationApi = {
  async createReservation(reservationData) {
    try {
      console.log('Using API URL:', API_BASE_URL); // Debug

      if (!API_BASE_URL) {
        throw new Error('URL de l\'API non configurée');
      }

      const dateObj = new Date(reservationData.date_appel);
      
      if (isNaN(dateObj.getTime())) {
        throw new Error('Date invalide');
      }

      const formattedDate = dateObj.toISOString().replace('T', ' ').replace(/\..+/, '');

      const payload = {
        ...reservationData,
        date_appel: formattedDate
      };

      const response = await fetch(`${API_BASE_URL}/reservation-appels`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        body: JSON.stringify(payload),
      });

      let responseData;
      const contentType = response.headers.get('content-type');
      if (contentType && contentType.includes('application/json')) {
        responseData = await response.json();
      } else {
        responseData = await response.text();
      }

      if (!response.ok) {
        throw new Error(
          responseData.message || 
          responseData || 
          `Erreur ${response.status}: ${response.statusText}`
        );
      }

      return responseData;
      
    } catch (error) {
      console.error('Erreur API:', {
        endpoint: `${API_BASE_URL}/reservation-appels`,
        error: error.message,
        data: reservationData
      });
      
      const userMessage = error.message.includes('Failed to fetch')
        ? 'Erreur de connexion au serveur. Veuillez réessayer plus tard.'
        : error.message;

      throw new Error(userMessage);
    }
  }
};